export const asleep = require("./asleep.jpg");
export const at_the_airport = require("./at_the_airport.jpg");
export const bike_investigation = require("./bike_investigation.jpg");
export const birthday_cat_tree = require("./birthday_cat_tree.jpg");
export const bott_and_tu = require("./bott_and_tu.jpg");
export const brave = require("./brave.jpg");
export const creature = require("./creature.jpg");
export const dinner_is_served = require("./dinner_is_served.jpg");
export const first_day_home_from_the_shelter = require("./first_day_home_from_the_shelter.jpg");
export const heart = require("./heart.jpg");
export const hello = require("./hello.jpg");
export const igloo = require("./igloo.jpg");
export const in_a_box = require("./in_a_box.jpg");
export const in_the_sheets = require("./in_the_sheets.jpg");
export const lacan = require("./lacan.jpg");
export const loaf = require("./loaf.jpg");
export const lumpy = require("./lumpy.jpg");
export const measure_theory = require("./measure_theory.jpg");
export const media_literacy = require("./media_literacy.png");
export const mondays = require("./mondays.jpg");
export const photo_bomb = require("./photo_bomb.jpg");
export const reaching = require("./reaching.jpg");
export const sniff_inspector = require("./sniff_inspector.jpg");
export const tasty_blanket = require("./tasty_blanket.jpg");
export const the_lamp = require("./the_lamp.jpg");
export const up_close_and_personal = require("./up_close_and_personal.jpg");
export const upside_down = require("./upside_down.jpg");
export const you_ve_got_mail = require("./you_ve_got_mail.jpg");
